import Vue from 'vue'

/**
 * @description 返回省份和来源，例如：福建 | 公共资源
 */
Vue.filter('updateSiteName', (val, param) => {
  let provinceName = param.provinceName || '';
  let siteName = null;
  if (param.purchaseSource == 6) {
    siteName = '广电';
  } else if (param.guildId && param.siteName) {
    if (param.guildId == 3) {
      if (param.siteName.indexOf('政府采购') != -1) {
        siteName = '政府采购';
      } else if (param.siteName.indexOf('公共资源') != -1) {
        siteName = '公共资源';
      } else {
        siteName = '综合';
      }
    } else if (param.guildId > 3) {
      siteName = '综合';
    } else {
      siteName = param.siteName;
    }
  }

  if (siteName == null) {
    siteName = param.areaOperation;
  }

  if (provinceName && siteName) {
    return provinceName + ' | ' + siteName;
  }

  if (siteName) {
    return siteName
  }

})



// WEBPACK FOOTER //
// ./src/common/js/filters.js